import moment from 'moment';

// convert unix ms timestamp into moment time object
export default function(ts) {
  if (!ts) return '';
  const seconds = ts.substring(0, ts.length - 3);
  return moment.unix(seconds);
}
